<div id="login" class="inner-scroll login-main">
  <div class="absolute inset-0 top-0 left-0">
    <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover" />
  </div>
  @if(!linkExpired){
  <div id="login-form-wrapper" class="login-wrapper bg-white">

    <div id="login-form" class="p-relative w-full shadow-none"
      [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
      <!-- Logo -->
      <div class="w-40 m-auto">
        <!-- <img src="images/logo/logo.svg" /> -->
        <img src="../images/new/biz-logo.png">
      </div>

      <!-- Title -->
      <div class="mt-5 auth-title">
        {{isSet?'SET':'Reset'}} your password
      </div>
      <div class="mt-0.5 font-medium">
        Create a new password for your account
      </div>


      <form class="mt-8" name="formResetPassword" [formGroup]="formResetPassword" (submit)="resetPassword()" novalidate>
        @if(isSet){
        <div class="message-box info mb-12">
          <span class="custom-span-pre">Email confirmed successfully , Now you can set your Password</span>
        </div>
        }

        @if(apiResponseErrorMessage!=null){
        <div class="message-box error mb-12">
          <span class="custom-span-pre">{{apiResponseErrorMessage}}</span>
        </div>
        }
        <mat-form-field>
          <input type="password" advs-compare="confirmPassword" matInput placeholder="Enter New Password" parent="true"
            required color="primary" formControlName="password">
          @if(formResetPassword.get('password').hasError('required')){
          <mat-error>
            Password is required
          </mat-error>
          }

          @if(!formResetPassword.get('password').hasError('required') &&
          formResetPassword.get('password').hasError('invalidPassword')){
          <mat-error>
            Minimum 6 characters,and combination of Alphanumeric and special character.
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input type="password" matInput placeholder="Enter Confirm Password" value="" required color="primary"
            advs-compare="password" parent='false' formControlName="confirmPassword">
          @if(formResetPassword.get('confirmPassword').hasError('required')){
          <mat-error>
            Confirm Password is required
          </mat-error>
          }
          @if(!formResetPassword.get('confirmPassword').hasError('required') &&
          formResetPassword.get('confirmPassword').errors){
          <mat-error>
            Password & Confirm Password did not match
          </mat-error>
          }
        </mat-form-field>
        <button type="submit" mat-raised-button class="fuse-mat-button-large submit-button bg-primary text-white w-full"
          [disabled]="!formResetPassword.valid||isSubmitBtnDisabled">
          {{isSet?'Set':'Reset'}} Password
        </button>
        <div class="message text-center">
          <a class="link text-primary-500 hover:underline" [routerLink]="'/auth/login'">Go back to login page</a>
        </div>
      </form>
    </div>
  </div>
  }
  @if(linkExpired){
  <div id="mail-confirm" fxLayout="column" fxLayoutAlign="center center">
    <div id="mail-confirm-form-wrapper">
      <div id="mail-confirm-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
        <div class="logo">
          <mat-icon class="mat-accent s-96">email</mat-icon>
        </div>
        <div class="title">Link Expired</div>
        <div class="subtitle">
          <p>
            Link you tried to access is expired.
          </p>
        </div>
        <div class="message">
          <a class="link" [routerLink]="'/auth/login'">Go back to login page</a>
        </div>
      </div>
    </div>
  </div>
  }

</div>